import React, { useRef, useState } from "react";
import HorizontalRadioButton from "./HorizontalRadioButton";

const HorizontalRadioButtonGroup = (props) => {
  const {
    options,
    selectedValue,
    setSelectedValue,
    appearance,
    disabled = false,
  } = props;
  const ref = useRef();
  const buttonRefs = useRef([]);
  const [isKeyboardFocus, setIsKeyboardFocus] = useState(false);

  const handleKeyDown = (event, index) => {
    if (!isKeyboardFocus) {
      return;
    }

    const selectedIndex = options.findIndex(
      (option) =>
        option.value === selectedValue || option.label === selectedValue
    );
    const isFirstButtonAndNoSelectedValue = selectedIndex === -1 && index === 0;

    if (selectedIndex !== index && !isFirstButtonAndNoSelectedValue) {
      return;
    }

    const eventKey = event.key;

    if (
      !["ArrowRight", "ArrowDown", "ArrowLeft", "ArrowUp", " "].includes(
        eventKey
      )
    ) {
      return;
    }

    event.preventDefault();

    let newIndex;
    if (eventKey === "ArrowRight" || eventKey === "ArrowDown") {
      newIndex = index + 1;

      if (newIndex >= options.length) {
        newIndex = 0;
      }
    } else if (eventKey === "ArrowLeft" || eventKey === "ArrowUp") {
      newIndex = index - 1;

      if (newIndex < 0) {
        newIndex = options.length - 1;
      }
    } else if (eventKey === " ") {
      newIndex = index;
    }

    setSelectedValue(options[newIndex]?.value || options[newIndex]?.label);
    if (buttonRefs.current?.[newIndex]) {
      buttonRefs.current[newIndex].focus();
    }
  };

  const handleOnClick = (event) => {
    setSelectedValue(event.target.value);
    setIsKeyboardFocus(false);
  };

  return (
    <div
      ref={ref}
      role="radiogroup"
      className={`radiogroup-horizontal-${
        appearance === "horizontalBlocks" ? "blocks" : "buttons"
      }`}
    >
      {options?.map((option, index) => {
        let { label, value } = option;

        if (typeof option === "string") {
          label = option;
          value = option;
        }

        return (
          <HorizontalRadioButton
            ref={(el) => (buttonRefs.current[index] = el)}
            key={`radioBtn-${index}`}
            className={`radiogroup-horizontal-${
              appearance === "horizontalBlocks"
                ? "blocks-block"
                : "buttons-button"
            }`}
            index={index}
            value={value || label}
            selected={selectedValue === value || selectedValue === label}
            appearance={appearance}
            disabled={disabled}
            selectedValue={selectedValue}
            onClick={handleOnClick}
            onKeyDown={(event, index) => handleKeyDown(event, index)}
            onFocus={() => setIsKeyboardFocus(true)}
          >
            {label}
          </HorizontalRadioButton>
        );
      })}
    </div>
  );
};

export default HorizontalRadioButtonGroup;
